// Map our in-app language codes to Intercom-supported ISO 639-1 codes for
// `language_override` (the field that controls the Messenger UI language).
// Most of our codes are already ISO; only Belarusian, Ukrainian, and
// Brazilian Portuguese diverge from ISO and need an explicit mapping -
// Intercom silently ignores `language_override` values it doesn't recognize.
// Shared between frontend (logged-in app) and landing so the Messenger UI
// stays consistent when a visitor migrates from one to the other.
var INTERCOM_LANG_OVERRIDES = {
  by: "be",
  ua: "uk",
  br: "pt-br",
}

function toIntercomLanguage(lang) {
  return INTERCOM_LANG_OVERRIDES[lang] || lang || ""
}

module.exports = {
  INTERCOM_LANG_OVERRIDES,
  toIntercomLanguage,
}
